import { useQuery } from '@apollo/client';
import CustomerOverdueBalanceQuery from '../../graphql/queries/salesLedger/CustomerOverdueBalanceQuery.graphql';
import {
  ICustomer,
  IOverdueBalance,
  ISalesOverdueBalanceQueryResult,
  ISalesOverdueBalanceQueryVariables,
} from '../../graphql/schema/p4types';
import { useMemo } from 'react';

export const useCustomerOverdueBalance = ({ values }: { values: ICustomer }) => {
  const { data: overdueBalanceData } = useQuery<ISalesOverdueBalanceQueryResult, ISalesOverdueBalanceQueryVariables>(
    CustomerOverdueBalanceQuery,
    {
      variables: {
        id: values?.id,
      },
      fetchPolicy: 'network-only',
      skip: !values?.id,
    }
  );

  const overdueBalance = overdueBalanceData?.data as IOverdueBalance;

  return useMemo(() => ({ overdueBalance }), [overdueBalance]);
};
